import {Brick, BrickContext, Predicate, registerBrick} from 'olympe';
import Component from "../../../models/Component";
import InspectionState from "../../../models/InspectionState";
import InspectionEntity from "../../../models/InspectionEntity";

export default class SubEntitiesFromComponents extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<!Component>} components
     * @param {boolean} filterByAvailability
     * @param {!Array<InspectionState>} unitStates
     * @param {function()} forwardEvent
     * @param {function(!Array<InspectionEntity>)} setEntities
     */
    update($, [components, filterByAvailability, unitStates], [forwardEvent, setEntities]) {
        const predicate = Predicate.or(...unitStates.map((state) => Predicate.contains(InspectionState.valueProp, state.getValue())));
        const entities = components.flatMap((component) => this.getSubEntities(component, filterByAvailability, predicate));
        setEntities(entities);
        forwardEvent();
    }

    /**
     * @private
     * @param {boolean} filterAvailable
     * @param {Component} component
     * @param {Predicate} predicate
     * @return {!Array}
     */
    getSubEntities(component, filterAvailable, predicate) {
        const subcomponents = component.follow(Component.subComponentsRel).executeFromCache().toArray();
        if (subcomponents.length > 0) {
            const subEntities = subcomponents.flatMap((subcomponent) => this.getSubEntities(subcomponent, filterAvailable, predicate));
            // Exclude the component if none of its sub entity is available.
            return subEntities.length > 0 ? [component].concat(subEntities) : [];
        }
        // No subcomponents => It is a leaf component so get inspections.
        else {
            let inspectionQuery = component.follow(Component.inspectionsRel).andReturn();
            if (filterAvailable) {
                inspectionQuery = inspectionQuery.follow(InspectionEntity.presumedStatesRel).filter(predicate);
            }
            const inspections = inspectionQuery.executeFromCache().toArray();
            return inspections.length > 0 ? [component].concat(inspections) : [];
        }
    }
}

registerBrick('01898ed112459b57277e', SubEntitiesFromComponents);
